"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, useRef } from 'react';
import { MagentoRawContentInteractions } from './MagentoRawContentInteractions';
import '@/styles/magento/fontawesome.css';
export interface ProductDetailsSection {
  id: string;
  label: string;
  /** Already sanitized on the server (renderProductHtmlServer). */
  html: string;
}
interface ProductDetailsTabsProps {
  sections: ProductDetailsSection[];
}
export function ProductDetailsTabs(t0) {
  const $ = _c(20);
  const {
    sections
  } = t0;
  const [activeId, setActiveId] = useState(sections[0]?.id);
  const tabsRef = useRef(null);
  const isInitialMount = useRef(true);
  let t1;
  let t2;
  if ($[0] !== activeId) {
    t1 = () => {
      if (isInitialMount.current) {
        isInitialMount.current = false;
        return;
      }
      if (activeId && tabsRef.current) {
        const activeButton = tabsRef.current.querySelector(`[data-tab-id="${activeId}"]`);
        if (activeButton) {
          activeButton.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center"
          });
        }
      }
    };
    t2 = [activeId];
    $[0] = activeId;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!sections.length) {
    return null;
  }
  let t3;
  if ($[3] !== activeId || $[4] !== sections) {
    t3 = sections.find(section => section.id === activeId)?.id ?? sections[0]?.id;
    $[3] = activeId;
    $[4] = sections;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const activeSectionId = t3;
  let t4;
  if ($[6] !== activeSectionId || $[7] !== sections) {
    t4 = sections.map((section_0, index) => {
      const isActive = section_0.id === activeSectionId;
      return <button key={section_0.id} type="button" role="tab" id={`tab-${section_0.id}`} aria-selected={isActive} aria-controls={`tabpanel-${section_0.id}`} tabIndex={isActive ? 0 : -1} data-tab-id={section_0.id} onClick={() => setActiveId(section_0.id)} className={`touch-target px-4 py-3 sm:px-5 sm:py-3 text-xs sm:text-sm font-semibold uppercase tracking-wide whitespace-nowrap transition-colors scroll-snap-align-start ${isActive ? "bg-background text-primary border-x border-t border-border -mb-px relative z-10" : "bg-primary/80 text-primary-foreground hover:bg-primary/90"}`} onKeyDown={e => {
        if (e.key === "ArrowRight") {
          const nextIndex = (index + 1) % sections.length;
          const nextSection = sections[nextIndex];
          if (nextSection) {
            setActiveId(nextSection.id);
          }
        } else {
          if (e.key === "ArrowLeft") {
            const prevIndex = (index - 1 + sections.length) % sections.length;
            const prevSection = sections[prevIndex];
            if (prevSection) {
              setActiveId(prevSection.id);
            }
          }
        }
      }}>{section_0.label}</button>;
    });
    $[6] = activeSectionId;
    $[7] = sections;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div ref={tabsRef} className="mobile-tabs border-b border-border" role="tablist" aria-label="Product details tabs">{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <MagentoRawContentInteractions />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== activeSectionId || $[13] !== sections) {
    let t8;
    if ($[15] !== activeSectionId) {
      t8 = section_1 => {
        const isActive_0 = section_1.id === activeSectionId;
        return <div key={section_1.id} id={`tabpanel-${section_1.id}`} role="tabpanel" aria-labelledby={`tab-${section_1.id}`} tabIndex={isActive_0 ? 0 : -1} hidden={!isActive_0} className="tabpanel-description border border-border border-t-0 bg-background p-4 sm:p-6"><div className="magento-raw-content" suppressHydrationWarning={true}><div suppressHydrationWarning={true} dangerouslySetInnerHTML={{
              __html: section_1.html
            }} /></div></div>;
      };
      $[15] = activeSectionId;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    t7 = sections.map(t8);
    $[12] = activeSectionId;
    $[13] = sections;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[17] !== t5 || $[18] !== t7) {
    t8 = <div className="product-details-tabs">{t5}{t6}{t7}</div>;
    $[17] = t5;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}